// @ts-ignore
import React, { startTransition } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { projectStepperSelectors, RootState } from '../../store';
import { ProjectStepTypes } from '../../interfaces';

const StyledProjectsNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const StyledNavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  svg {
    color: grey;
  }

  &:hover {
    svg {
      color: lightskyblue;
    }
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.2;

    &:hover {
      svg {
        color: grey;
      }
    }
  }
`;

export const ProjectStepNavigation = () => {
  const { slug: urlSlug, projectId } = useParams();
  const navigate = useNavigate();

  const steps = useSelector((state: RootState) => state.projectStepper.steps);

  const stepsLength = steps.length;

  const currentRailItem = useSelector((state: RootState) => projectStepperSelectors.selectCurrentStep(state, urlSlug));

  const currentIndex =
    urlSlug === ProjectStepTypes.COMPLETE
      ? steps?.length
      : steps?.findIndex((item: any) => item?.slug === currentRailItem?.slug);

  const label = currentRailItem?.displayName || '';

  const handleNavClick = (event: React.MouseEvent<HTMLButtonElement>, newIndex: number) => {
    event.preventDefault();
    const { slug } = steps[newIndex] || {};

    // handle complete step navigation
    if (newIndex === steps?.length) {
      navigate(`/my-workspace/projects/${projectId}/${ProjectStepTypes.COMPLETE}`);
      return;
    }

    if (!slug) {
      console.error('Could not navigate to the next step. Missing step data!');
      return;
    }

    startTransition(() => {
      navigate(`/my-workspace/projects/${projectId}/${slug}`);
    });
  };

  return (
    <StyledProjectsNavigation>
      <StyledNavButton
        type="button"
        onClick={(event) => handleNavClick(event, currentIndex - 1)}
        disabled={currentIndex === 0}
      >
        <KeyboardDoubleArrowLeftOutlinedIcon />
      </StyledNavButton>

      <h4>{label}</h4>

      {/*this [currentIndex >= stepsLength] is intentionally left to allow pass over step length so we could display completed page */}
      <StyledNavButton
        type="button"
        onClick={(event) => handleNavClick(event, currentIndex + 1)}
        disabled={currentIndex >= stepsLength}
      >
        <KeyboardDoubleArrowRightOutlinedIcon />
      </StyledNavButton>
    </StyledProjectsNavigation>
  );
};
